import React, { useEffect, useState } from 'react'
import { onIdTokenChanged } from 'firebase/auth'
import { firebaseAuth } from './../../../../api/FirebaseAuth'

// Uses the MODULAR Firebase API and the single `firebaseAuth` instance exported by
// src/api/FirebaseAuth.js. Do not switch this to `firebase/compat/*`: compat keeps a
// separate app registry that FirebaseAuth.js never populates, so compat auth calls
// throw `app-compat/no-app`. See docs/REACT-18-MIGRATION.md (UAD-3606).

const decodeExpiry = token => {
  if (!token) return null
  try {
    const [, payload] = token.split('.')
    const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))
    return decoded.exp ? new Date(decoded.exp * 1000) : null
  } catch (e) {
    return null
  }
}

const AuthDebug = () => {
  const [user, setUser] = useState(null)
  const [token, setToken] = useState(null)
  const [now, setNow] = useState(Date.now())

  useEffect(() => {
    const off = onIdTokenChanged(firebaseAuth, async u => {
      if (!u) {
        setUser(null)
        setToken(null)
        return
      }
      setUser({
        uid: u.uid,
        email: u.email,
        displayName: u.displayName,
      })
      try {
        const t = await u.getIdToken(false)
        setToken(t)
      } catch (e) {
        setToken(null)
      }
    })
    const tick = setInterval(() => setNow(Date.now()), 1000)
    return () => {
      if (typeof off === 'function') off()
      clearInterval(tick)
    }
  }, [])

  const expiry = decodeExpiry(token)
  const secondsToExpiry = expiry ? Math.max(0, Math.round((expiry.getTime() - now) / 1000)) : null

  const copyToken = () => {
    if (!token) return
    navigator.clipboard.writeText(token)
  }

  return (
    <div className='ws-card'>
      <h5>Firebase Auth</h5>
      {!user && <div className='text-muted small'>Not signed in.</div>}
      {user && (
        <>
          <div className='small'>
            <strong>UID:</strong> <code>{user.uid}</code>
          </div>
          <div className='small'>
            <strong>Email:</strong> {user.email || '(none)'}
          </div>
          <div className='small mt-2'>
            <strong>ID Token:</strong>{' '}
            {token ? (
              <button type='button' className='btn btn-link p-0 small' onClick={copyToken}>
                copy
              </button>
            ) : null}
          </div>
          <div className='ws-token-field'>{token ? `${token.slice(0, 32)}…${token.slice(-16)}` : '(no token)'}</div>
          {expiry && (
            <div className='small mt-2 text-muted'>
              Expires in <strong>{secondsToExpiry}s</strong> ({expiry.toLocaleTimeString()})
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default AuthDebug
